const removeSearchFromUrl = (url: string) => {
  const urlObject = new URL(url);
  urlObject.search = "";
  return urlObject.toString();
};

export default removeSearchFromUrl;
